import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  buttonStyle: { marginHorizontal: scale(16) },
  logoutButtonPadding: {
    paddingHorizontal: 10,
    paddingVertical: 5,
  },
});
export default styles;
